
import * as React from "react";
import { callApi } from "../../utils/api";
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore
} from "react-toasts";
import { Link } from "react-router-dom";

declare var $: any;

interface AllProps {
    history: any;
    match: any;
    path: any;
}
class VisitorList extends React.Component<AllProps> {
    state = {
        bank_name: "",
        selectVal: false,
        setResponse: true,
        lookup: '',
        fileId: '',
        sampleId: "",
        id: "",
        fromDate: "",
        toDate: "",
        notications: [],
        users: [],
        total: '',
        green: '',
        red: '',
    };
    obj: any;
    table: any;
    componentDidMount() {
        this.getVisitorList();
        const user: any = localStorage.getItem("user");
        this.setState({ user: user ? JSON.parse(user)["userId"] : "" })
    }
    getVisitorList = () => {
        callApi("POST", "visitor_get.php")
            .then((res: any) => res.data)
            .then(response => {
                var visitors = response.data
                visitors = visitors.reverse();
                let notications = [];
                this.setState({ notications: visitors });
                if ($.fn.dataTable.isDataTable('#processeodTable')) {
                    this.table = $('#processeodTable').DataTable({
                        paging: true,
                        dom: 'Bfrtip',
                        buttons: [{ extend: 'excel', text: "Download As Excel" }]
                    });

                }
                else {
                    this.table = $('#processeodTable').DataTable({
                        paging: true,
                        dom: 'Bfrtip',
                        buttons: [{ extend: 'excel', text: "Download As Excel" }]
                    });
                }
            })
            .catch(err => {
                console.log(err);
            });
    }
    onchangeReason = (e: any) => {

        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false })
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        }
        else if (e.target.value == "select") {
            this.setState({ setResponse: false })
        }
        else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };
    onchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
    };


    handleChange1 = (e, propName?, fieldType?) => {
        let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
        let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;
        if (fieldName === "lawhands_branch") {
            const branch = fieldValue;
            const filteredUsers = this.state.users.filter(
                (itm: any) => itm.branch_id === branch
            );
            this.setState({ [fieldName]: fieldValue });
            this.setState({ filteredUsers });
        }
        if (fieldName === "assigned_to") {
            const employee_id = fieldValue;
            this.setState({ [fieldName]: fieldValue });
        }
        if (fieldName === "bank_name") {
            const bank_name = fieldValue;
            this.setState({ [fieldName]: fieldValue });
        }
    }
    handleChange = (e, stateName?, type?) => {
        if (e.target.name === "bank_name") {
            this.setState({ todate: e.target.value })
        }
        if (e.target.name === "toDate") {
            this.setState({ todate: e.target.value })
        }
        if (e.target.name === "fromDate") {
            this.setState({ fromdate: e.target.value })
        }
        if (e.target.name === "id") {
            this.setState({ id: e.target.value })
        }
        if (e.target.name === "lawhands_branch") {
            const branch = e.target.value;
            const filteredUsers = this.state.users.filter(
                (itm: any) => itm.branch_id === branch
            );
            this.setState({ filteredUsers });
        }
        this.setState({ [e.target.name]: e.target.value });
    };
    handleDateChange = (date, dateStr, type) => {
        this.setState({ [type]: dateStr });
    };

    renderVisitorList = () => {
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="card" style={{ overflow: 'hidden' }}>
                        <div className="card-header" style={{
                            padding: "10px",
                            textAlign: "center"
                        }}>
                            <h5 style={{
                                fontSize: "21px",
                                fontWeight: "bold"
                            }}>Visitor's List</h5>
                            <Link
                                to={{ pathname: "/visitor/add/" }}
                                className="btn btn-outline-secondary" style={{ fontWeight: "bold", borderWidth: "2px", padding: "3px 5px", float: "right" }}>
                                Add Visitor
                            </Link>
                        </div>

                        <div className="card-body">
                            <div className="dt-responsive table-responsive visitor-table">
                                <table
                                    id="processeodTable"
                                    className="table table-striped table-bordered nowrap"
                                >
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>visitor Name</th>
                                            <th>Phone Number</th>
                                            <th>Bank Name</th>
                                            <th>Purpose</th>
                                            <th>Visited Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.notications && this.state.notications.length
                                            ? this.state.notications.map(
                                                (query: any, index: number) => {
                                                    return (
                                                        <tr className="query-table-row cursor-pointer" key={index}>
                                                            <td className="text-align-center">{index + 1}</td>
                                                            <td className="click">
                                                                {query.visitor_name}
                                                            </td>
                                                            <td className="click">
                                                                {query.phone_no}
                                                            </td>
                                                            <td className="click">
                                                                {query.bank_name}
                                                            </td>
                                                            <td className="click">
                                                                {query.purpose}
                                                            </td>
                                                            <td className="click">
                                                                {query.date}
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )
                                            : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <>
                {this.props.path == "unAuth" ?
                    <>
                        {this.renderVisitorList()};
                    </> :
                    <>
                        <section className="pcoded-main-container">
                            <ToastsContainer
                                store={ToastsStore}
                                position={ToastsContainerPosition.TOP_RIGHT}
                            />{" "}
                            <div className="pcoded-wrapper">
                                <div className="pcoded-content">
                                    <div className="pcoded-inner-content">
                                        <div className="main-body">
                                            <div className="page-wrapper">
                                                {this.renderVisitorList()};
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                }

            </>
        );
    }
}


export default VisitorList;

function x(arg0: string, x: any) {
    throw new Error("Function not implemented.");
}
